import NextImage from 'next/legacy/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import type { FunctionComponent } from 'react'
import style from './ProductSearchCard.module.sass'

type ProductSearchCardProps = {
	title: string | undefined
	specification?: string
	url: string
	imageUrl?: string
	closeModal: () => void
}

export const ProductSearchCard: FunctionComponent<ProductSearchCardProps> = ({
	title,
	specification,
	url,
	imageUrl,
	closeModal,
}) => {
	const router = useRouter()

	const onClick = () => {
		closeModal()
		router.push(url)
	}
	return (
		<Link onClick={onClick} href={url} className={style.root} title={title}>
			<div className={style.card}>
				<div className={style.imageWrapper}>
					<div className={style.image}>
						<NextImage
							src={imageUrl ?? '/images/placeholder-product.png'}
							alt={title ?? ''}
							layout="fill"
							objectFit="contain"
						/>
					</div>
				</div>
				<div className={style.header}>
					{title && <div className={style.title}>{title}</div>}
					<p className={style.specification}>{specification}</p>
				</div>
			</div>
		</Link>
	)
}
